/* @generated from adl module ferovinum.sourcecontracts.purchaser */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.purchaser` contract.
 */
export interface PurchaserSource {
  id: ferovinum_app_db.PurchaserId;
  accountCode: string;
  name: string;
  currency: common_strings.StringNE;
  crnNumber: (common_strings.StringNE|null);
  vatNumber: (common_strings.StringNE|null);
  awrsRegistrationNumber: (common_strings.StringNE|null);
  xeroContactId: (string|null);
  paymentTermsId: (ferovinum_app_db.PaymentTermsId|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makePurchaserSource(
  input: {
    id: ferovinum_app_db.PurchaserId,
    accountCode: string,
    name: string,
    currency: common_strings.StringNE,
    crnNumber: (common_strings.StringNE|null),
    vatNumber: (common_strings.StringNE|null),
    awrsRegistrationNumber: (common_strings.StringNE|null),
    xeroContactId: (string|null),
    paymentTermsId: (ferovinum_app_db.PaymentTermsId|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): PurchaserSource {
  return {
    id: input.id,
    accountCode: input.accountCode,
    name: input.name,
    currency: input.currency,
    crnNumber: input.crnNumber,
    vatNumber: input.vatNumber,
    awrsRegistrationNumber: input.awrsRegistrationNumber,
    xeroContactId: input.xeroContactId,
    paymentTermsId: input.paymentTermsId,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const PurchaserSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.purchaser","decl":{"annotations":[{"value":{"modelName":"source__app_db.purchaser","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.purchaser` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaserId"}},"parameters":[]}},{"annotations":[],"serializedName":"accountCode","default":{"kind":"nothing"},"name":"accountCode","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"crnNumber","default":{"kind":"nothing"},"name":"crnNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vatNumber","default":{"kind":"nothing"},"name":"vatNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"awrsRegistrationNumber","default":{"kind":"nothing"},"name":"awrsRegistrationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"xeroContactId","default":{"kind":"nothing"},"name":"xeroContactId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"paymentTermsId","default":{"kind":"nothing"},"name":"paymentTermsId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PaymentTermsId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"PurchaserSource","version":{"kind":"nothing"}}};

export const snPurchaserSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.purchaser", name:"PurchaserSource"};

export function texprPurchaserSource(): ADL.ATypeExpr<PurchaserSource> {
  return {value : {typeRef : {kind: "reference", value : snPurchaserSource}, parameters : []}};
}

/**
 * The published `source__app_db.purchaser__accounts_emails_unpack` contract (fanout sibling).
 */
export interface PurchaserAccountsEmailsUnpackSource {
  purchaserId: ferovinum_app_db.PurchaserId;
  accountsEmailsIdx: number;
  accountsEmail: (common_strings.StringNE|null);
}

export function makePurchaserAccountsEmailsUnpackSource(
  input: {
    purchaserId: ferovinum_app_db.PurchaserId,
    accountsEmailsIdx: number,
    accountsEmail: (common_strings.StringNE|null),
  }
): PurchaserAccountsEmailsUnpackSource {
  return {
    purchaserId: input.purchaserId,
    accountsEmailsIdx: input.accountsEmailsIdx,
    accountsEmail: input.accountsEmail,
  };
}

const PurchaserAccountsEmailsUnpackSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.purchaser","decl":{"annotations":[{"value":{"modelName":"source__app_db.purchaser__accounts_emails_unpack","grain":["purchaser_id","accounts_emails_idx"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.purchaser__accounts_emails_unpack` contract (fanout sibling).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"purchaserId","default":{"kind":"nothing"},"name":"purchaserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaserId"}},"parameters":[]}},{"annotations":[],"serializedName":"accountsEmailsIdx","default":{"kind":"nothing"},"name":"accountsEmailsIdx","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"accountsEmail","default":{"kind":"nothing"},"name":"accountsEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"PurchaserAccountsEmailsUnpackSource","version":{"kind":"nothing"}}};

export const snPurchaserAccountsEmailsUnpackSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.purchaser", name:"PurchaserAccountsEmailsUnpackSource"};

export function texprPurchaserAccountsEmailsUnpackSource(): ADL.ATypeExpr<PurchaserAccountsEmailsUnpackSource> {
  return {value : {typeRef : {kind: "reference", value : snPurchaserAccountsEmailsUnpackSource}, parameters : []}};
}

/**
 * The published `source__app_db.purchaser__feature_flags_unpack` contract (fanout sibling).
 */
export interface PurchaserFeatureFlagsUnpackSource {
  purchaserId: ferovinum_app_db.PurchaserId;
  featureFlagsIdx: number;
  featureFlag: (common_strings.StringNE|null);
}

export function makePurchaserFeatureFlagsUnpackSource(
  input: {
    purchaserId: ferovinum_app_db.PurchaserId,
    featureFlagsIdx: number,
    featureFlag: (common_strings.StringNE|null),
  }
): PurchaserFeatureFlagsUnpackSource {
  return {
    purchaserId: input.purchaserId,
    featureFlagsIdx: input.featureFlagsIdx,
    featureFlag: input.featureFlag,
  };
}

const PurchaserFeatureFlagsUnpackSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.purchaser","decl":{"annotations":[{"value":{"modelName":"source__app_db.purchaser__feature_flags_unpack","grain":["purchaser_id","feature_flags_idx"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.purchaser__feature_flags_unpack` contract (fanout sibling).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"purchaserId","default":{"kind":"nothing"},"name":"purchaserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaserId"}},"parameters":[]}},{"annotations":[],"serializedName":"featureFlagsIdx","default":{"kind":"nothing"},"name":"featureFlagsIdx","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"featureFlag","default":{"kind":"nothing"},"name":"featureFlag","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"PurchaserFeatureFlagsUnpackSource","version":{"kind":"nothing"}}};

export const snPurchaserFeatureFlagsUnpackSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.purchaser", name:"PurchaserFeatureFlagsUnpackSource"};

export function texprPurchaserFeatureFlagsUnpackSource(): ADL.ATypeExpr<PurchaserFeatureFlagsUnpackSource> {
  return {value : {typeRef : {kind: "reference", value : snPurchaserFeatureFlagsUnpackSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.purchaser.PurchaserSource" : PurchaserSource_AST,
  "ferovinum.sourcecontracts.purchaser.PurchaserAccountsEmailsUnpackSource" : PurchaserAccountsEmailsUnpackSource_AST,
  "ferovinum.sourcecontracts.purchaser.PurchaserFeatureFlagsUnpackSource" : PurchaserFeatureFlagsUnpackSource_AST
};
